import axios from '../../common/utils/interceptor';
import { apiUrls, SessionStore } from '../../constants';

export const checkIfVideoFeedbackRequestSent = async (): Promise<boolean> => {
  try {
    const { data } = await axios.get(apiUrls.GET_VIDEO_FEEDBACK_GENERATION_REQUEST_STATUS);
    if (data.readyForGeneration) {
      sessionStorage.setItem(SessionStore.isVideoFeedbackGenerationRequested, 'true');
      return true;
    }
  } catch (e) {
    console.error('Video Feedback Generation Request status error: ', e);
  }
  return false;
};
